import React, { useEffect, useState } from "react";
import axios from "axios";

const PaymentSuccessfull = () => {
  const [invoice, setInvoice] = useState("");

  useEffect(() => {
    const email = localStorage.getItem("mail_for_get_invoice")
    const getInvoice = () => {
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/attendees/latest-attendee-event`,
          { email }
        )
        .then((response) => {
          setInvoice(response?.data?.latestTransaction?.invoice);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    };
    getInvoice();
  }, []);

  return (
    <div className="flex h-screen items-center justify-center bg-gray-100">
      <div className="bg-white p-6  md:mx-auto">
       
        <svg
          viewBox="0 0 24 24"
          className="mx-auto my-6 h-16 w-16 text-green-600"
        >
          <path
            fill="currentColor"
            d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
          ></path>
        </svg>
        <div className="text-center">
          <h3 className="text-center text-base font-semibold text-gray-900 md:text-2xl">
            Payment Done!
          </h3>
          <p className="my-2 text-gray-600">
            Thank you for completing your secure online payment.
          </p>
          <p> Have a great day! </p>
          <div className="py-10 flex gap-3 text-center justify-center">
            <a
              href="/"
              className="bg-indigo-600 px-12 py-3 font-semibold text-white hover:bg-indigo-500"
            >
              GO BACK
            </a>
            <a
              className="bg-green-600 px-12 py-3 font-semibold text-white hover:bg-green-500"
              href={invoice}
              download
            >
               Receipt
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessfull;
